export default{
    methods:{
        getAnimationDelay(idx, type) {
            // 越往后的数据延迟越大
            let len = idx * 300;
            
            if (type === "line") {
                len = idx * 2000;
            }
            return len;
        }
    }
}